<template>
    <div v-if="!loading">
        <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>

        <b-form>
            <div class="row" ref="formTop">
                <b-card class="col-sm-12 col-md-12 col-lg-12">
                    <b-card-title title-tag="h5" :title="siteRaw ? 'Edit Site' : 'Create Site'"></b-card-title>
                    <b-card-body class="px-0">
                        <b-form-group label="Name" label-for="name">
                            <b-form-input id="name" v-model="site.title" :state="errors.title ? false : null"></b-form-input>
                            <b-form-invalid-feedback id="input-live-feedback">{{ errors.title ? errors.title[0] : '' }}</b-form-invalid-feedback>
                        </b-form-group>
                        <b-form-group label="Short Code" label-for="longName">
                            <b-form-input id="longName" v-model="site.shortcode" :state="errors.shortcode ? false : null"></b-form-input>
                            <b-form-invalid-feedback id="input-live-feedback">{{ errors.shortcode ? errors.shortcode[0] : '' }}</b-form-invalid-feedback>
                        </b-form-group>
                        <b-button @click="createSite" variant="primary">Submit</b-button>
                    </b-card-body>
                </b-card>
            </div>
        </b-form>
    </div>
</template>

<script>
export default {
    props: {
        siteRaw: {
            default: false,
        }
    },
    data() {
        return {
            breadcrumbItems: [],
            site: {
                id: null,
                title: '',
                shortcode: '',
            },
            loading: true,
            errors: [],
        }
    },
    methods: {
        buildBreadcrumbItems() {
            this.breadcrumbItems = [
                {text: 'Sites', href: this.$routes.route('site.index')},
                {text: this.siteRaw ? 'Edit Site' : 'Create Site', active: true},
            ];
        },
        createSite() {
            if (this.site.id) {
                axios.put(this.$routes.route('site.update', {'site': this.site.id}), this.site)
                    .then((response) => {
                        this.site = {
                            id: null,
                            title: '',
                            shortcode: '',
                        };

                        window.location.href = this.$routes.route('site.index');
                    })
                    .catch(error => {
                        this.errors = error.response.data.errors;
                    });
            } else {
                axios.post(this.$routes.route('site.store'), this.site)
                    .then((response) => {
                        this.site = {
                            id: null,
                            title: '',
                            shortcode: '',
                        };

                        window.location.href = this.$routes.route('site.index');
                    })
                    .catch(error => {
                        this.errors = error.response.data.errors;
                    });
            }
        },
    },
    mounted() {
        this.loading = true;
        if (this.siteRaw) {
            axios.get(this.$routes.route('site.show', {'site': this.siteRaw.id}))
                .then(response => {
                    this.site = response.data;
                    this.buildBreadcrumbItems();
                    this.loading = false;
                })
                .catch(error => {
                    console.log(error);
                });
        } else {
            this.buildBreadcrumbItems();
            this.loading = false;
        }
    },
}
</script>